import { render, staticRenderFns } from "./wdmr_record.vue?vue&type=template&id=8e468042"
import script from "./wdmr_record.vue?vue&type=script&lang=js"
export * from "./wdmr_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports